<template>
  <div class="login container">
    <div v-if="!redeemTicketPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>
    <form v-else @submit.prevent="$nextTick(submit)">

      <div class="d-flex justify-content-between">
        <div class="col-xs-6 pl-3 pt-5">
          <cta link="home" shape="circle" icon="left-arrow" text="" margin="no-margin" />
        </div>

        <div class="col-xs-6  pr-3 pt-5">
          <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="!ticket_reference || errors.has('ticket_reference')" margin="no-margin" :loading="submitted" />
        </div>
      </div>

      <p class="small-header-text">Ticket code</p>
      <h2>{{ticket.ticket_reference}}</h2>
      <div class="spacer"></div>

      <p class="large-header-text mt-4">{{$route.params.message}}</p>

      <div class="spacer"></div>

      <cta type="submit" text="Try again"/>

    </form>

  </div>
</template>

<script>

export default {
  name: 'Login',
  components: {
  },
  inject: ['$validator'],
  data : function(){       
      return {
        ticket_reference: '',
        submitted     : false,
        error:'',
        destroyed: false
      };

  },

  computed: {
    
    ticket() {
      return this.$store.getters.getTicket;
    },
 
  },
  methods:{
    submit() {
      this.$router.push({ name: 'scan'});
    }
  }
}
</script>

<style scoped>
.loader {
  position: absolute;
}

.small-header-text {
  font-size: 1.3em;
  margin: 0;
}

.medium-header-text {
  font-size: 1.6em;
  margin: 0;
}

.large-header-text {
  font-size: 2.7em;
}

.spacer {
  height: 1em;
}

.ticket-cta-container {
  column-gap: 4em;
}
</style>